"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var FileLambdaFill = function FileLambdaFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = (0, _objectWithoutProperties2["default"])(_ref, ["color", "size"]);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    shapeRendering: "geometricPrecision",
    viewBox: "0 0 24 24"
  }, props, {
    height: size,
    width: size,
    style: {
      color: color
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    stroke: color,
    d: "M18 2a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2h12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "var(--geist-icons-background)",
    stroke: "none",
    d: "M7.716 6.783c0-.433.353-.783.79-.783.679 0 1.314.056 1.878.44.532.363.893.948 1.268 1.658l.009.015 1.053 2.229 2.333 4.835.005.009.164.355c.078.17.142.31.207.44.101.204.165.296.21.345l.003.004c.022.027.086.105.575.105.436 0 .789.35.789.782a.786.786 0 01-.79.783c-.683 0-1.278-.113-1.743-.619a3.01 3.01 0 01-.459-.704c-.076-.152-.159-.334-.247-.526l-.14-.303-1.72-3.563-3.446 5.353a.794.794 0 01-1.09.239.779.779 0 01-.24-1.08l3.976-6.178-.855-1.81c-.377-.71-.583-.96-.756-1.079-.143-.097-.353-.165-.985-.165a.786.786 0 01-.79-.782z"
  }));
};
var _default = FileLambdaFill;
exports["default"] = _default;